
function toCurrencyFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits:2, maximumFractionDigits: 2});
}

function toNumberFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"decimal", minimumFractionDigits:2, maximumFractionDigits: 2});
}
function toNumberFormatSize(snumber) {
    snumber=snumber*10;    
    return parseFloat(snumber).toLocaleString("en-US", {style:"decimal", minimumFractionDigits:2, maximumFractionDigits: 2});
}
function checkImageExists(imageUrl, callback) {
    var img = new Image();
    img.onload = function() {
        // The image loaded successfully
        callback(true);
    };
    img.onerror = function() {
        // The image could not be loaded
        callback(false);
    };
    img.src = imageUrl;
}

function calcDeliveryDate(country, city) {    
    let months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];    

    let nroDays = 0;
    if (country != 'USA') {
        nroDays = 10;
    }

    if (country === 'USA' && city != 'New York') {
        nroDays = 9;
    }

    if (country === 'USA' && city === 'New York') {
        nroDays = 7;
      $('.static_tabs .quick-ship').show();
    }else{
     $('.static_tabs .quick-ship').hide(); 
    }

    let deliveryDate = new Date();
    deliveryDate.setDate(deliveryDate.getDate() + nroDays);

    let month = months[deliveryDate.getMonth()];
    let day = deliveryDate.getDate().toString();
    let nroEnd = day.charAt(day.length - 1);
    
    let ordinal;
    if (day === '11' || day === '12' || day === '13') {
        ordinal = 'th.';
    }
    else {
        switch (nroEnd) {
            case '1':
                ordinal = 'st.';
                break;
            case '2':
                ordinal = 'nd.';
                break;
            case '3':
                ordinal = 'rd.';
                break;        
            default:
                ordinal = 'th.';
                break;
        }
    }

    let delivery = month + ' ' + day + ordinal
    console.log("<<<<<<<<here delievery date"+delivery);
    return delivery;
}

function getDiamondUrl(shape) {
    let shapesrc;

    switch (shape) {
        case "Round":
            shapesrc = "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/round_new.png?v=1663593132";
            break;
        case "Radiant":
            shapesrc = "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/radiant_new.png?v=1663593295";
            break;
        case "Princess":
            shapesrc = "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/princess_diamond_shape.png?v=1662396478";
            break;
        case "Pear":
            shapesrc = "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/pear_diamond_shape.png?v=1662396478";
            break;
        case "Oval":
            shapesrc = "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/oval_diamond_shape.png?v=1662396478";
            break;
        case "Marquise":
            shapesrc = "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/marquise_diamond_shape.png?v=1662396478";
            break;
        case "Heart":
            shapesrc = "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/heart_diamond_shape.png?v=1662396478";
            break;
        case "Emerald":
            shapesrc = "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/emerald_diamond_shape.png?v=1662396478";
            break;
        case "Cushion":
            shapesrc = "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/cushion_diamond_shape.png?v=1662396478";
            break;
        case "Asscher":
            shapesrc = "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/asscher_diamond_shape.png?v=1662396478";
            break;
        default:
            shapesrc = "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/round_diamond_shape.png?v=1662396478";
            break;
    }

    return shapesrc;
}

function calcTreePercen(price){

    return price/100;

}

function isImage(url) {
    if(url === undefined || url === null) return false;
    return(url.match(/\.(jpeg|jpg|gif|png)$/) != null);
}

function isV360(url){
    if(url.indexOf('360') > -1){
        return true;
    }
    else{
        return false;
    }
}

function getCaratDictionaryValue(carat){
    // get the integer part of the carat
    // Determine the lower bound
  let lowerBound = Math.floor(carat);
  let remainder = carat - lowerBound;
  let topNumber;
  if (remainder < 0.30) {
    topNumber = lowerBound + 0.29;
  } else if (remainder < 0.46) {
    topNumber = lowerBound + 0.45;
  } else {
    topNumber = lowerBound + 0.99;
  }

  // Increment the lower bound for the next range
  let increment = (lowerBound % 2 === 0) ? 0.46 : 0.53;
  if (carat > topNumber) {
    topNumber = lowerBound + increment + 0.99;
  }
  return 'dyo_carat_' + topNumber.toFixed(2).replace(".","-");
}


function isRoundImgTest(diamond){
    return diamond.Shape2.toLowerCase() == 'round' && diamond.Cut2.replace(" ","-").toLowerCase() == 'excellent' && diamond.Color2.toLowerCase() == 'j'
}

async function callOneDiamond(diamond_id) {

    let url = window.API_URL +`diamonds/new/dyor/settings/${diamond_id}`;
    let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));
    
    fetch(url, {
        method: 'GET',        
        headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
    }).then(res => res.json())
        .then(async diamond => {   
          var rendom_another_bag =   localStorage.getItem('rendom_another_bag');
          console.log(diamond,'abcxyz')
            if(diamond.Diamond_ID2 == undefined){
             window.location.href = window.location.origin + '/pages/dyoe-diamond';
            }
            if(diamond){
            let vendorName = diamond.Seller_Name2;
            console.log(vendorName);
            if(vendorName != undefined || vendorName != null ){
              var url = window.API_URL + `diamonds/diamondShipping/singlevendorShowShipping/${vendorName}`;
              var settings = {
                  "url": url,
                  "method": "GET",
                  "timeout": 0,
                  "headers": {
                  "X-API-Key": "TSANITY121A3VG7NEMVRXXEWGM"
                  },
                };
                $.ajax(settings).done(function (response) {
                 var shipping_date = response.shipping_date;
                 let type = updateLocalStorageWizard(diamond, diamond.Weight2, diamond.Total_Price2,url,shipping_date);
                });
              }
            }
            let currentCurrency = Shopify.currency.active;
            let currentCurrencySymbol = $('body').attr('data-currency');
            let currentRate = window.Shopify.currency.rate;
            let treePercent = toNumberFormat(calcTreePercen(diamond.Total_Price2));          
            let price = currentCurrencySymbol+''+toNumberFormat(diamond.Total_Price2 * currentRate + diamond.Total_Price1 * currentRate);
            let price2 = currentCurrencySymbol+''+toNumberFormat(diamond.Total_Price2 * currentRate);
            let price1 = currentCurrencySymbol+''+toNumberFormat(diamond.Total_Price1 * currentRate);
            let carat = toNumberFormat(diamond.Weight2);  
            let carat1 = toNumberFormat(diamond.Weight1);  
            let delivery = calcDeliveryDate(diamond.Country, diamond.City);
            $("#deliverydate").html(delivery);
            console.log("having delievery date=>"+delivery);
            let totalCarat = parseFloat(carat) + parseFloat(carat1);
            let roundedTotalCarat = totalCarat.toFixed(2);
            var url;
            url =  getDiamondUrl(diamond.Shape2);          
            let type = updateLocalStorageWizard(diamond, diamond.Weight2, diamond.Total_Price2,url);
            let wizardStart = JSON.parse(window.localStorage.getItem('wizardStart'));
            if(wizardStart == 'StartWithDiamond'){
                document.getElementById('diamond-with-setting').innerText = 'Use this Diamond';
            }
           let diamond_shap = diamond.Shape2;
          if(diamond_shap == 'Square Emerald'){
            diamond_shap = 'Asscher';
          }
            document.getElementById('first-title').innerHTML = `${roundedTotalCarat} Carat ${diamond_shap} Diamond`;
            var diamond_title = `${carat} Carat ${diamond.Shape2} Diamond`;
            var pinteresturl = $('.social-media__item-list .social-media__item--pinterest a').attr('href');
           pinteresturl = pinteresturl.replace('media_file', url);
           pinteresturl = pinteresturl.replace('diamond-description',diamond_title);
           $('.social-media__item-list .social-media__item--pinterest a').attr('href',pinteresturl);
           var twitterturl = $('.social-media__item-list .social-media__item--twitter a').attr('href');
            twitterturl = twitterturl.replace('twitter_text', diamond_title);
          $('.social-media__item-list .social-media__item--twitter a').attr('href',twitterturl);
            document.getElementById('price').innerHTML = `${price}`;
            
            
            if(diamond.Shape2 == 'Round'){
                document.getElementById('cutInfo').innerHTML = `${diamond.Cut2} Cut`; 
            }
            else {
                document.getElementById('cutInfoContainer').remove();
            }               
            
            let sizemm=toNumberFormatSize(diamond.Weight2);
            document.getElementById('lab').innerHTML = `${diamond.Lab2}`;
            document.getElementById('color').innerHTML = `${diamond.Color2} Color`;
            document.getElementById('clarity').innerHTML = ` ${diamond.Clarity2} Clarity`;
            document.getElementById('measure').innerHTML = ` ${diamond.Measurements2}`;

          if(diamond.Shape1 == 'Round'){
                document.getElementById('cutInfo2').innerHTML = `${diamond.Cut1} Cut`; 
            }
            else {
                document.getElementById('cutInfoContainer').remove();
            }               
            
            document.getElementById('lab2').innerHTML = `${diamond.Lab1}`;
            document.getElementById('color2').innerHTML = `${diamond.Color1} Color`;
            document.getElementById('clarity2').innerHTML = ` ${diamond.Clarity1} Clarity`;
            document.getElementById('measure2').innerHTML = ` ${diamond.Measurements1}`;
           
           
       
            if (diamond.Measurements2!='') {
                document.getElementById('detail-measurements').innerHTML = `${diamond.Measurements2}`;                
            } else {
                document.getElementById('detail-measurements-div').classList.add('div_empty');
            }
         
            if (diamond.Shape2!='') {
                document.getElementById('detail-shape').innerHTML = `${diamond.Shape2}`;                
            }else{
            document.getElementById('detail-shape-div').classList.add('div_empty');
            } 
            if (diamond.Total_Price2!='') {
                document.getElementById('detail-price').innerHTML = `${toCurrencyFormat(diamond.Total_Price2)}`;                
            }else{
            document.getElementById('detail-price-div').classList.add('div_empty');
            }
            if (diamond.Stock_Number2!='') {
                document.getElementById('detail-number').innerHTML = `${diamond.Stock_Number2}`;                
            } else {
                document.getElementById('detail-number-div').classList.add('div_empty');
            }
            if (carat!='') {
                document.getElementById('detail-carat').innerHTML = `${carat}`; 
                document.getElementById('accent_carat_size').value = `${carat}`;
            } else {
                document.getElementById('detail-carat-div').classList.add('div_empty');
            }

            if (diamond.Cut2!='') {
                document.getElementById('detail-cut').innerHTML = `${diamond.Cut2}`;                
            } else {
                document.getElementById('detail-cut-div').classList.add('div_empty');
            }

            if (diamond.Color2!='') {
                document.getElementById('detail-color').innerHTML = `${diamond.Color2}`; 
                document.getElementById('detail-color-value').value = `${diamond.Color2}`;
            } else {
                document.getElementById('detail-color-div').classList.add('div_empty');
            }

            if (diamond.Clarity2!='') {
                document.getElementById('detail-clarity').innerHTML = `${diamond.Clarity2}`; 
                document.getElementById('detail-clarity-value').value = `${diamond.Clarity2}`;
            } else {
                document.getElementById('detail-clarity-div').classList.add('div_empty');
            }
            
            if (diamond.Table2!='') {
                document.getElementById('detail-table').innerHTML = `${diamond.Table2}`;                
            } else {
                document.getElementById('detail-table-div').classList.add('div_empty');                
            }
            if (diamond.Depth2!='') {
                document.getElementById('detail-depth').innerHTML = `${diamond.Depth2}`;                
            } else {
                document.getElementById('detail-depth-div').classList.add('div_empty');                
            }
            if (diamond.Depth2!='') {
                document.getElementById('detail-depth').innerHTML = `${diamond.Depth2}`;                
            } else {
                document.getElementById('detail-depth-div').classList.add('div_empty');                
            }
            if (diamond.Symmetry2!='') {
                document.getElementById('detail-symmetry').innerHTML = `${diamond.Symmetry2}`;                
            } else {
                document.getElementById('detail-symmetry-div').classList.add('div_empty');                
            }
            if (diamond.Polish2!='') {
                document.getElementById('detail-polish').innerHTML = `${diamond.Polish2}`;                
            } else {
                document.getElementById('detail-polish-div').classList.add('div_empty');                
            }
            if (diamond.Girdle2!='') {
                document.getElementById('detail-girdle').innerHTML = `${diamond.Girdle2}`;                
            } else {
                document.getElementById('detail-girdle-div').classList.add('div_empty');                
            }
            if (diamond.Culet_Size2!='') {
                document.getElementById('detail-culet').innerHTML = `${diamond.Culet_Size2}`;                
            } else {
                document.getElementById('detail-culet-div').classList.add('div_empty');                
            }
            if (diamond.Fluorescence_Intensity2 != '') {
                document.getElementById('detail-fluorescence_intensity').innerHTML = `${diamond.Fluorescence_Intensity2}`;                
            } else {
                document.getElementById('detail-fluorescence_intensity-div').classList.add('div_empty');                
            }
            if (diamond.Ratio2!='') {
                document.getElementById('detail-ratio').innerHTML = `${diamond.Ratio2}`;                
            } else {
                document.getElementById('detail-ratio').classList.add('div_empty');                
            }




            if (diamond.Measurements1!='') {
                document.getElementById('detail-measurements2').innerHTML = `${diamond.Measurements1}`;                
            } else {
                document.getElementById('detail-measurements-div2').classList.add('div_empty');
            }
            
            if (diamond.Shape1!='') {
                document.getElementById('detail-shape2').innerHTML = `${diamond.Shape1}`;                
            }else{
            document.getElementById('detail-shape-div2').classList.add('div_empty');
            } 
            if (diamond.Total_Price1!='') {
                document.getElementById('detail-price2').innerHTML = `${toCurrencyFormat(diamond.Total_Price1)}`;                
            }else{
            document.getElementById('detail-price-div2').classList.add('div_empty');
            }
            
            if (carat1!='') {
                document.getElementById('detail-carat2').innerHTML = `${carat1}`; 
                document.getElementById('accent_carat_size2').value = `${carat1}`;
            } else {
                document.getElementById('detail-carat-div2').classList.add('div_empty');
            }

            if (diamond.Cut1!='') {
                document.getElementById('detail-cut2').innerHTML = `${diamond.Cut1}`;                
            } else {
                document.getElementById('detail-cut-div2').classList.add('div_empty');
            }

            if (diamond.Color1!='') {
                document.getElementById('detail-color2').innerHTML = `${diamond.Color1}`; 
                document.getElementById('detail-color-value2').value = `${diamond.Color1}`;
            } else {
                document.getElementById('detail-color-div2').classList.add('div_empty');
            }

            if (diamond.Clarity1!='') {
                document.getElementById('detail-clarity2').innerHTML = `${diamond.Clarity1}`; 
                document.getElementById('detail-clarity-value2').value = `${diamond.Clarity1}`;
            } else {
                document.getElementById('detail-clarity-div2').classList.add('div_empty');
            }
            
            if (diamond.Table1!='') {
                document.getElementById('detail-table2').innerHTML = `${diamond.Table1}`;                
            } else {
                document.getElementById('detail-table-div2').classList.add('div_empty');                
            }
            if (diamond.Depth1!='') {
                document.getElementById('detail-depth2').innerHTML = `${diamond.Depth1}`;                
            } else {
                document.getElementById('detail-depth-div2').classList.add('div_empty');                
            }
            if (diamond.Depth1!='') {
                document.getElementById('detail-depth2').innerHTML = `${diamond.Depth1}`;                
            } else {
                document.getElementById('detail-depth-div2').classList.add('div_empty');                
            }
            if (diamond.Symmetry1!='') {
                document.getElementById('detail-symmetry2').innerHTML = `${diamond.Symmetry1}`;                
            } else {
                document.getElementById('detail-symmetry-div2').classList.add('div_empty');                
            }
            if (diamond.Polish1!='') {
                document.getElementById('detail-polish2').innerHTML = `${diamond.Polish1}`;                
            } else {
                document.getElementById('detail-polish-div2').classList.add('div_empty');                
            }
            if (diamond.Girdle1!='') {
                document.getElementById('detail-girdle2').innerHTML = `${diamond.Girdle1}`;                
            } else {
                document.getElementById('detail-girdle-div2').classList.add('div_empty');                
            }
            if (diamond.Culet_Size1!='') {
                document.getElementById('detail-culet2').innerHTML = `${diamond.Culet_Size1}`;                
            } else {
                document.getElementById('detail-culet-div2').classList.add('div_empty');                
            }
            if (diamond.Fluorescence_Intensity1 != '') {
                document.getElementById('detail-fluorescence_intensity2').innerHTML = `${diamond.Fluorescence_Intensity1}`;                
            } else {
                document.getElementById('detail-fluorescence_intensity-div2').classList.add('div_empty');                
            }
            if (diamond.Ratio1!='') {
                document.getElementById('detail-ratio2').innerHTML = `${diamond.Ratio1}`;                
            } else {
                document.getElementById('detail-ratio2').classList.add('div_empty');                
            }

          
           

          
            if (diamond.Certificate_URL2===''||diamond.Certificate_URL2=== null|| diamond.Certificate_URL2=== undefined) {
                
                document.getElementById('certified').innerHTML=`<h3>N/A</h3>`;
                
            } else {
                   var certificate_image=`https://dsv7iunirnrax.cloudfront.net/gia_certificate/certificate_${diamond.Certificate_Number2}.jpeg`;
                   var certificate_image1=`https://dsv7iunirnrax.cloudfront.net/gia_certificate/certificate_${diamond.Certificate_Number1}.jpeg`;
                checkImageExists(certificate_image, function(exists) {
                    if (exists) {
                        document.getElementById('certified').innerHTML=`<a target="_blank" href="${certificate_image}" class="content_popup"><img width="100%" src="${certificate_image}" alt="certificate"></a><span class="diamondtext">Diamond 1</span><a target="_blank" href="${certificate_image1}" class="content_popup"><img width="100%" src="${certificate_image1}" alt="certificate"></a><span class="diamondtext">Diamond 2</span>`;
                    } else {
                        document.querySelector('#certified').innerHTML=`<a href="${diamond.Certificate_URL2}" target="_blank">Diamond 1 Certificate</h3><br><br><a href="${diamond.Certificate_URL1}" target="_blank">Diamond 2 Certificate 2</h3>`;
                    }
                });
                document.getElementById('certLabName').innerHTML=`${diamond.Lab2}`;
            }




          
           if(diamond.Column812.indexOf('d=') > -1 && diamond.Column812.indexOf('surl=') > -1){
                   var Videourl=diamond.Column812;
                if(diamond.Column812.startsWith("?d")){
                  Videourl=`https://jeronone.com/test-server/boski/Truesanity-video/360-video.php${diamond.Column812}&isPreload=1`;
                }else{
                  Videourl = `https://jeronone.com/test-server/boski/Truesanity-video/360-video.php?${Videourl.split('?')[1]}&isPreload=1`;
                }
                  document.getElementById('diamond-image1').innerHTML = `<div class="main_video_container a"><img class="play_btn" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID2}.jpeg"/><iframe data-scaling="true"  seamless="seamless" src="${Videourl}" scrolling="no" width=420 height=420></iframe><span class="diamondtext">Diamond 1</span></div>`;
                  document.querySelector('.diamond-image-mob-1').classList.add("mob-iframe");
                  document.querySelector('.diamond-image-mob-1').innerHTML = `<div class="main_video_container b"><img class="play_btn" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID2}.jpeg"/><iframe src="${Videourl}" scrolling="no" width=420 height=420></iframe></div>`;
                }
                  else if(diamond.Column812.indexOf('.mp4') > -1 || diamond.Column812.indexOf('.MP4') > -1){
                  var Videourl=diamond.Column812;
                  document.querySelector('.diamond-image-mob-1').innerHTML = `<div class="main_container_first mp4_video"><div class="main_video_container c"><img class="play_btn" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID2}.jpg"/><video style="width:100%" autoplay playsinline="" loop muted><source src="${Videourl}" type="video/mp4"> </video></div></div>`;
                  document.getElementById('diamond-image1').innerHTML = `<div class="main_video_container d"><img class="play_btn" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID2}.jpg"/><video width="420" height="420" autoplay playsinline="" loop muted><source src="${Videourl}" type="video/mp4"> </video><span class="diamondtext">Diamond 1</span></div>`;  
                }else if(diamond.Column812 !=''){
                     document.getElementById('diamond-image1').innerHTML = `<div class="main_video_container e"><iframe src="${diamond.Column812}"  scrolling="no" width=420 height=420></iframe></div>`;
                     document.querySelector('.diamond-image-mob-1').innerHTML = `<div class="main_container_first mob-iframe"><div class="main_video_container f"><img class="play_btn" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID2}.jpeg"/><iframe src="${diamond.Column812}" scrolling="no" width=420 height=420></iframe></div>`;
                }
                else{
                  if(isImage(diamond.Image_URL)){
                  document.getElementById('diamond-img1').src = `${diamond.Image_URL}`;
                  document.getElementById('diamond-img1-mobile').src = `${diamond.Image_URL}`;
                  }       
                  else{
                  
                    if(isV360(diamond.Image_URL)){
                      //set the innerHTML to an iframe loading diamond.Image_URL
                    document.getElementById('diamond-image1').innerHTML = `<div class="main_video_container f"><img class="play_btn" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID2}.jpeg"/><iframe src="${diamond.Image_URL}" scrolling="no" width=420 height=420></iframe><span class="diamondtext">Diamond 1</span></div>`;
                    document.querySelector('.diamond-image-mob-1').innerHTML = `<div class="main_container_first mob-iframe"><div class="main_video_container g"><img class="play_btn" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID2}.jpeg"/><iframe src="${diamond.Image_URL}" scrolling="no" width=420 height=420></iframe></div></div>`;
                    }
                    else {
                      document.getElementById('diamond-img1').src = 'https://dummyimage.com/420x420/c9c9c9/000000?text='+diamond.Shape2.toLowerCase()+'_'+diamond.Color2.toLowerCase()+"_main.png";
                      document.getElementById('diamond-img1-mobile').src = 'https://dummyimage.com/420x420/c9c9c9/000000?text='+diamond.Shape2.toLowerCase()+'_'+diamond.Color2.toLowerCase()+"_main.png";
                    
                    }
                  }
                }


          if(diamond.Column811.indexOf('d=') > -1 && diamond.Column811.indexOf('surl=') > -1){
                   var Videourl1=diamond.Column811;
                if(diamond.Column811.startsWith("?d")){
                  Videourl=`https://jeronone.com/test-server/boski/Truesanity-video/360-video.php${diamond.Column811}&isPreload=1`;
                }else{
                  Videourl = `https://jeronone.com/test-server/boski/Truesanity-video/360-video.php?${Videourl1.split('?')[1]}&isPreload=1`;
                }
                  document.getElementById('diamond-image2').innerHTML = `<div class="main_video_container h"><img class="play_btn" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID1}.jpeg"/><iframe data-scaling="true"  seamless="seamless" src="${Videourl1}" scrolling="no" width=420 height=420></iframe><span class="diamondtext">Diamond 2</span></div>`;
                  document.querySelector('.diamond-image-mob-2').classList.add("mob-iframe");
                  document.querySelector('.diamond-image-mob-2').innerHTML = `<div class="main_video_container i"><img class="play_btn" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID1}.jpeg"/><iframe src="${Videourl1}" scrolling="no" width=420 height=420></iframe></div>`;
                }
                  else if(diamond.Column811.indexOf('.mp4') > -1 || diamond.Column811.indexOf('.MP4') > -1){
                  var Videourl1=diamond.Column811;
                  document.querySelector('.diamond-image-mob-2').innerHTML = `<div class="main_container_first mp4_video"><div class="main_video_container j"><img class="play_btn" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID1}.jpg"/><video style="width:100%" autoplay playsinline="" loop muted><source src="${Videourl1}" type="video/mp4"> </video></div></div>`;
                  document.getElementById('diamond-image2').innerHTML = `<div class="main_video_container k"><video width="420" height="420" autoplay playsinline="" loop muted><source src="${Videourl1}" type="video/mp4"> </video><span class="diamondtext">Diamond 2</span></div>`;  
                }else if(diamond.Column811 !=''){
                     document.getElementById('diamond-image2').innerHTML = `<div class="main_video_container l"><img class="play_btn" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID1}.jpeg"/><iframe src="${diamond.Column811}"  scrolling="no" width=420 height=420></iframe><span class="diamondtext">Diamond 2</span></div>`;
                     document.querySelector('.diamond-image-mob-2').innerHTML = `<div class="main_container_first mob-iframe"><div class="main_video_container m"><img class="play_btn" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID1}.jpeg"/><iframe src="${diamond.Column811}" scrolling="no" width=420 height=420></iframe></div></div>`;
                }
                else{
                  if(isImage(diamond.Image_URL)){
                  document.getElementById('diamond-img2').src = `${diamond.Image_URL}`;
                  document.getElementById('diamond-img2-mobile').src = `${diamond.Image_URL}`;
                  }       
                  else{
                  
                    if(isV360(diamond.Image_URL)){
                      //set the innerHTML to an iframe loading diamond.Image_URL
                    document.getElementById('diamond-image2').innerHTML = `<div class="main_video_container n"><img class="play_btn" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID1}.jpeg"/><iframe src="${diamond.Image_URL}" scrolling="no" width=420 height=420></iframe><span class="diamondtext">Diamond 2</span></div>`;
                    document.querySelector('.diamond-image-mob-2').innerHTML = `<div class="main_container_first mob-iframe"><div class="main_video_container o"><img class="play_btn" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID1}.jpeg"/><iframe src="${diamond.Image_URL}" scrolling="no" width=420 height=420></iframe></div></div>`;
                    }
                    else {
                      document.getElementById('diamond-img2').src = 'https://dummyimage.com/420x420/c9c9c9/000000?text='+diamond.Shape2.toLowerCase()+'_'+diamond.Color2.toLowerCase()+"_main.png";
                      document.getElementById('diamond-img2-mobile').src = 'https://dummyimage.com/420x420/c9c9c9/000000?text='+diamond.Shape2.toLowerCase()+'_'+diamond.Color2.toLowerCase()+"_main.png";
                    
                    }
                  }
                }
            //document.getElementById('diamond-img1').src = `${url}`;         
            /*
            Now let's add the renders
            Cut is only available for Round shapes
            */
            var cutImgPath = ''
            if(diamond.Shape2 == 'Round'){
              cutImgPath = '_'+diamond.Cut2.replace(" ","-").toLowerCase(); // _very-good
            }
            
            //If is mobile populate the carousel
            if (window.innerWidth < 768) {
                console.log("Mobile carousel loading");
                if(isRoundImgTest(diamond)){
                    document.getElementById('diamond-img2-mobile').src = 'https://cdn.shopify.com/s/files/1/0576/3350/5416/files/diamond_'+diamond.Shape.toLowerCase()+cutImgPath+'_'+diamond.Color.toLowerCase()+"_straight.png?v=1687876835";
                    // document.getElementById('diamond-img3-mobile').src = 'https://cdn.shopify.com/s/files/1/0576/3350/5416/files/diamond_'+diamond.Shape.toLowerCase()+cutImgPath+'_'+diamond.Color.toLowerCase()+"_side.png?v=1687876835";
                    // document.getElementById('diamond-img4-mobile').src = 'https://cdn.shopify.com/s/files/1/0576/3350/5416/files/diamond_'+diamond.Shape.toLowerCase()+cutImgPath+"_sketch_1.png?v=1687876835";
                    // document.getElementById('diamond-img5-mobile').src = 'https://cdn.shopify.com/s/files/1/0576/3350/5416/files/diamond_'+diamond.Shape.toLowerCase()+cutImgPath+'_'+diamond.Color.toLowerCase()+"_sketch_2.png?v=1687876835";    
                }
                else {
                    if (diamond && diamond.Shape && diamond.Color) {
                            document.getElementById('diamond-img2-mobile').src = 'https://dummyimage.com/420x420/c9c9c9/000000?text='+diamond.Shape.toLowerCase()+'_'+diamond.Color.toLowerCase()+cutImgPath+"_straight.png";
                    }
                    // document.getElementById('diamond-img3-mobile').src = 'https://dummyimage.com/420x420/c9c9c9/000000?text='+diamond.Shape.toLowerCase()+'_'+diamond.Color.toLowerCase()+cutImgPath+"_side.png";
                    // document.getElementById('diamond-img4-mobile').src = 'https://dummyimage.com/420x420/c9c9c9/000000?text='+diamond.Shape.toLowerCase()+'_'+diamond.Color.toLowerCase()+cutImgPath+"_sketch_1.png";
                    // document.getElementById('diamond-img5-mobile').src = 'https://dummyimage.com/420x420/c9c9c9/000000?text='+diamond.Shape.toLowerCase()+'_'+diamond.Color.toLowerCase()+cutImgPath+"_sketch_2.png";    
                }
               if($('#diamond-image1 video').length > 0){
                 var vid = $(".main_container_first video source").attr('src');
                  if(diamond.img_status == 1){
                   document.getElementById('diamond-img2-mobile').src = `https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID}.jpg`;
                   $('#carouselExampleIndicators .carousel-inner').slick({dots: true,arrows:true});
                  }
                }else if($('#diamond-image1 iframe').length > 0 ){
                 if(diamond.img_status == 1){
                   document.getElementById('diamond-img2-mobile').src = `https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID}.jpeg`;
                   $('#carouselExampleIndicators .carousel-inner').slick({dots: true,arrows:true});
                 }else{
                   $('#carouselExampleIndicators .carousel-inner').slick({dots: true,arrows:true});
                 }
                 
                }
            }
            else {
            
                // Populate Desktop
                if(isRoundImgTest(diamond)){
                    //document.getElementById('diamond-img2').src = 'https://cdn.shopify.com/s/files/1/0576/3350/5416/files/diamond_'+diamond.Shape2.toLowerCase()+cutImgPath+'_'+diamond.Color2.toLowerCase()+"_straight.png?v=1687876835";
                    // document.getElementById('diamond-img3').src = 'https://cdn.shopify.com/s/files/1/0576/3350/5416/files/diamond_'+diamond.Shape.toLowerCase()+cutImgPath+'_'+diamond.Color.toLowerCase()+"_side.png?v=1687876835";
                    // document.getElementById('diamond-img4').src = 'https://cdn.shopify.com/s/files/1/0576/3350/5416/files/diamond_'+diamond.Shape.toLowerCase()+cutImgPath+'_'+diamond.Color.toLowerCase()+"_sketch_1.png?v=1687876835";
                    // document.getElementById('diamond-img5').src = 'https://cdn.shopify.com/s/files/1/0576/3350/5416/files/diamond_'+diamond.Shape.toLowerCase()+cutImgPath+'_'+diamond.Color.toLowerCase()+"_sketch_2.png?v=1687876835";    

                }
                else{
                  //document.getElementById('diamond-img2').src = 'https://dummyimage.com/420x420/c9c9c9/000000?text='+diamond.Shape2.toLowerCase()+'_'+diamond.Color2.toLowerCase()+cutImgPath+"_straight.png";
                    // document.getElementById('diamond-img3').src = 'https://dummyimage.com/420x420/c9c9c9/000000?text='+diamond.Shape.toLowerCase()+'_'+diamond.Color.toLowerCase()+cutImgPath+"_side.png";
                    // document.getElementById('diamond-img4').src = 'https://dummyimage.com/420x420/c9c9c9/000000?text='+diamond.Shape.toLowerCase()+'_'+diamond.Color.toLowerCase()+cutImgPath+"_sketch_1.png";
                    // document.getElementById('diamond-img5').src = 'https://dummyimage.com/420x420/c9c9c9/000000?text='+diamond.Shape.toLowerCase()+'_'+diamond.Color.toLowerCase()+cutImgPath+"_sketch_2.png";
                
                }
               if($('#diamond-image1 video').length > 0){
               if(diamond.img_status == 1){
                  document.getElementById('diamond-img2').src = `https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID2}.jpg`;
                  }
               }else if(diamond.img_status == 1){
                  document.getElementById('diamond-img2').src = `https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID2}.jpeg`;
                  }
            }

          
          if (diamond.Image_URL === '' || diamond.Image_URL === null || diamond.Image_URL === undefined) {                
                document.getElementsByClassName('img-diamond-picture')[0].style.backgroundColor = '#FFFFFF';                
            } else {          
                document.getElementsByClassName('img-diamond-picture')[0].style.backgroundColor = '#FFFFFF'; 
            }

            document.getElementById('container-main').classList.remove('hidden');
            load4Cs();
            await loadComparator(diamond);
     
          let diamond_skeleton_img1 = '';
          let diamond_skeleton_img2 = '';
          switch (diamond.Shape2) {
            case 'Round':
              diamond_skeleton_img1 =  document.getElementById("container-main").getAttribute("data-side-round");
              diamond_skeleton_img2 =  document.getElementById("container-main").getAttribute("data-front-round");
              break;
            case 'Oval':
              diamond_skeleton_img1 = document.getElementById("container-main").getAttribute("data-side-oval");
              diamond_skeleton_img2 = document.getElementById("container-main").getAttribute("data-front-oval");
              break;
            case 'Cushion':
              diamond_skeleton_img1 = document.getElementById("container-main").getAttribute("data-side-cushion");
              diamond_skeleton_img2 = document.getElementById("container-main").getAttribute("data-front-cushion");
              break;
            case 'Pear':
              diamond_skeleton_img1 = document.getElementById("container-main").getAttribute("data-side-pear");
              diamond_skeleton_img2 = document.getElementById("container-main").getAttribute("data-front-pear");
              break;
            case 'Princess':
              diamond_skeleton_img1 = document.getElementById("container-main").getAttribute("data-side-princess");
              diamond_skeleton_img2 = document.getElementById("container-main").getAttribute("data-front-princess");
              break;
            case 'Emerald':
              diamond_skeleton_img1 = document.getElementById("container-main").getAttribute("data-side-emerald");
              diamond_skeleton_img2 = document.getElementById("container-main").getAttribute("data-front-emerald");
              break;
            case  'Marquise':
              diamond_skeleton_img1 = document.getElementById("container-main").getAttribute("data-side-marquise");
              diamond_skeleton_img2 = document.getElementById("container-main").getAttribute("data-front-marquise");
              break;
            case  'Asscher':
              diamond_skeleton_img1 = document.getElementById("container-main").getAttribute("data-side-asscher");
              diamond_skeleton_img2 = document.getElementById("container-main").getAttribute("data-front-asscher");
              break;
            case  'Radiant':
              diamond_skeleton_img1 = document.getElementById("container-main").getAttribute("data-side-radiant");
              diamond_skeleton_img2 = document.getElementById("container-main").getAttribute("data-front-radiant");
              break;
            case  'Heart':
              diamond_skeleton_img1 = document.getElementById("container-main").getAttribute("data-side-heart");
              diamond_skeleton_img2 = document.getElementById("container-main").getAttribute("data-front-heart");
              break;
          }


          
          let diamond_table = '';
          let diamond_girdle = '';
          let diamond_culet = '';
          let diamond_depth = '';
          
          if(diamond.Table2 != null && diamond.Table2  != ''){
             diamond_table = diamond.Table2
          }else{
            diamond_table = 'Null'
          }
          if(diamond.Girdle2 != null && diamond.Girdle2 != ''){
             diamond_girdle = diamond.Girdle2.split('-')[0]
          }else{
            diamond_girdle ='Null'
          }
           if(diamond.Culet2 != null && diamond.Culet2 != ''){
             diamond_culet =diamond.Culet2
          }else{
            diamond_culet ='Null'
          }
          if(diamond.Depth2 != null && diamond.Depth2 != ''){
             diamond_depth =diamond.Depth2
          }else{
            diamond_depth ='Null'
          }

 
          let diamond_table1 = '';
          let diamond_girdle1 = '';
          let diamond_culet1 = '';
          let diamond_depth1 = '';
          
          if(diamond.Table1 != null && diamond.Table1  != ''){
             diamond_table1 = diamond.Table1
          }else{
            diamond_table1 = 'Null'
          }
          if(diamond.Girdle1 != null && diamond.Girdle1 != ''){
             diamond_girdle1 = diamond.Girdle1.split('-')[0]
          }else{
            diamond_girdle1 ='Null'
          }
           if(diamond.Culet1 != null && diamond.Culet1 != ''){
             diamond_culet1 =diamond.Culet1
          }else{
            diamond_culet1 ='Null'
          }
          if(diamond.Depth1 != null && diamond.Depth1 != ''){
             diamond_depth1 =diamond.Depth1
          }else{
            diamond_depth1 ='Null'
          }


          
         let depth  = diamond.Measurements2.split('x');
        let depth1  = diamond.Measurements1.split('x');
         $('div#info-section #diamond-image3').html(`<div class="diamond-data ${diamond.Shape2}"><span id="table" class="sidetxt Cushion">Table:${diamond_table}</span><span id="t2" class="sidetxt Cushion">Girdle:${diamond_girdle}</span><span id="t3" class="sidetxt Cushion">Culet:${diamond_culet}</span><span id="t4" class="sidetxt Cushion">Depth:${diamond_depth}<br/>${depth[2]}mm</span></div><img src=${diamond_skeleton_img1} alt="" id="diamond-img3"><span class="diamondtext">Diamond 1</span>`);
         $('.carousel-inner .diamond-image-mob-3').html(`<div class="diamond-data ${diamond.Shape2}"><span id="table" class="sidetxt Cushion">Table:${diamond_table}</span><span id="t2" class="sidetxt Cushion">Girdle:${diamond_girdle}</span><span id="t3" class="sidetxt Cushion">Culet:${diamond_culet}</span><span id="t4" class="sidetxt Cushion">Depth:${diamond_depth}</span></div><img src=${diamond_skeleton_img1} alt="" id="diamond-img3">`)

         $('div#info-section #diamond-image5').html(`<div class="diamond-data ${diamond.Shape1}"><span id="table" class="sidetxt Cushion">Table:${diamond_table1}</span><span id="t2" class="sidetxt Cushion">Girdle:${diamond_girdle1}</span><span id="t3" class="sidetxt Cushion">Culet:${diamond_culet1}</span><span id="t4" class="sidetxt Cushion">Depth:${diamond_depth1}<br/>${depth1[2]}mm</span></div><img src=${diamond_skeleton_img1} alt="" id="diamond-img5"><span class="diamondtext">Diamond 2</span>`);
         $('.carousel-inner .diamond-image-mob-5').html(`<div class="diamond-data ${diamond.Shape1}"><span id="table" class="sidetxt Cushion">Table:${diamond_table1}</span><span id="t2" class="sidetxt Cushion">Girdle:${diamond_girdle1}</span><span id="t3" class="sidetxt Cushion">Culet:${diamond_culet1}</span><span id="t4" class="sidetxt Cushion">Depth:${diamond_depth1}</span></div><img src=${diamond_skeleton_img1} alt="" id="diamond-img5">`)
          
         let length = diamond.Measurements2.split('x')[0];
         let width  = diamond.Measurements2.split('x')[1];
         let length1 = diamond.Measurements1.split('x')[0];
         let width1  = diamond.Measurements1.split('x')[1];
         $('div#info-section #diamond-image4').html(`<div class="diamond-data ${diamond.Shape2}"><span id="t5" class="sidetxt Cushion">Lenght:${length}</span><span id="t6" class="sidetxt Cushion">Width:${width}</span></div><img src=${diamond_skeleton_img2} alt="" id="diamond-img4"><span class="diamondtext">Diamond 1</span>`);
         $('.carousel-inner .diamond-image-mob-4').html(`<div class="diamond-data ${diamond.Shape2}"><span id="t5" class="sidetxt Cushion">Lenght:${length}</span><span id="t6" class="sidetxt Cushion">Width:${width}</span></div><img src=${diamond_skeleton_img2} alt="" id="diamond-img4">`)
        
        $('div#info-section #diamond-image6').html(`<div class="diamond-data ${diamond.Shape1}"><span id="t5" class="sidetxt Cushion">Lenght:${length1}</span><span id="t6" class="sidetxt Cushion">Width:${width1}</span></div><img src=${diamond_skeleton_img2} alt="" id="diamond-img6"><span class="diamondtext">Diamond 2</span>`);
         $('.carousel-inner .diamond-image-mob-6').html(`<div class="diamond-data ${diamond.Shape1}"><span id="t5" class="sidetxt Cushion">Lenght:${length1}</span><span id="t6" class="sidetxt Cushion">Width:${width1}</span></div><img src=${diamond_skeleton_img2} alt="" id="diamond-img6">`)
            
          
          var plotting_image=`https://dsv7iunirnrax.cloudfront.net/plotting_diagram/plotting_diagrams_${diamond.Certificate_Number2}.jpg`;
          var plotting_image2=`https://dsv7iunirnrax.cloudfront.net/plotting_diagram/plotting_diagrams_${diamond.Certificate_Number2}.jpeg`;
          var proportions_image=`https://dsv7iunirnrax.cloudfront.net/proportions_diagram/proportions_diagrams_${diamond.Certificate_Number2}.jpg`;
          var proportions_image2=`https://dsv7iunirnrax.cloudfront.net/proportions_diagram/proportions_diagrams_${diamond.Certificate_Number2}.jpeg`;
          var gia_certificate_image=`https://dsv7iunirnrax.cloudfront.net/gia_certificate/certificate_${diamond.Certificate_Number2}.jpeg`;


          var plotting_image1 =`https://dsv7iunirnrax.cloudfront.net/plotting_diagram/plotting_diagrams_${diamond.Certificate_Number1}.jpg`;
          var plotting_image12 =`https://dsv7iunirnrax.cloudfront.net/plotting_diagram/plotting_diagrams_${diamond.Certificate_Number1}.jpeg`;
          var proportions_image1 =`https://dsv7iunirnrax.cloudfront.net/proportions_diagram/proportions_diagrams_${diamond.Certificate_Number1}.jpg`;
          var proportions_image12 =`https://dsv7iunirnrax.cloudfront.net/proportions_diagram/proportions_diagrams_${diamond.Certificate_Number1}.jpeg`;
          var gia_certificate_image1 =`https://dsv7iunirnrax.cloudfront.net/gia_certificate/certificate_${diamond.Certificate_Number1}.jpeg`; 
          
          var flag_slider = 0;
          var count = 0;
         
           checkImageExists(proportions_image2, function(exists) {
           
             if (exists) {
                        $('div#info-section #diamond-image3').html(`<div class="diamond-data ${diamond.Shape2}"><span id="table" class="sidetxt Cushion">Table:${diamond.Table2}</span><span id="t2" class="sidetxt Cushion">Girdle:${diamond.Girdle2}</span><span id="t3" class="sidetxt Cushion">Culet:${diamond.Culet}</span><span id="t4" class="sidetxt Cushion">Depth:${diamond.Depth2}</span></div><img src="${proportions_image2}" alt="" id="diamond-img3">`);
                        $('.carousel-inner .diamond-image-mob-3').html(`<div class="diamond-data ${diamond.Shape2}"><span id="table" class="sidetxt Cushion">Table:${diamond.Table2}</span><span id="t2" class="sidetxt Cushion">Girdle:${diamond.Girdle2}</span><span id="t3" class="sidetxt Cushion">Culet:${diamond.Culet}</span><span id="t4" class="sidetxt Cushion">Depth:${diamond.Depth2}</span></div><img src="${proportions_image2}" alt="" id="diamond-img4">`);
                    }
            });
            
            checkImageExists(plotting_image2, function(exists) {
              if (exists) { 
                        $('div#info-section #diamond-image4').html(`<div class="diamond-data ${diamond.Shape2}"><span id="t5" class="sidetxt Cushion">Lenght:${length}</span><span id="t6" class="sidetxt Cushion">Width:${width}</span></div><img src="${plotting_image2}" alt="" id="diamond-img4">`);
                       $('.carousel-inner .diamond-image-mob-4').html(`<div class="diamond-data ${diamond.Shape2}"><span id="t5" class="sidetxt Cushion">Lenght:${length}</span><span id="t6" class="sidetxt Cushion">Width:${width}</span></div><img src="${plotting_image2}" alt="" id="diamond-img4">`);
                    }
 
                });
           
          checkImageExists(gia_certificate_image, function(exists) {
            count = count +1;
                    if (exists) {
                        $('div#info-section #diamond-image7').html(`<img src="${gia_certificate_image}" alt="" id="diamond-img3"><span class="diamondtext">Diamond 1</span>`);
                      $('.carousel-inner .diamond-image-mob-7').html(`<img src="${gia_certificate_image}" alt="" id="diamond-img5new">`);
                    } 
            });


           checkImageExists(proportions_image12, function(exists) {
              if (exists) { 
                        $('div#info-section #diamond-image5').html(`<div class="diamond-data ${diamond.Shape1}"><span id="table" class="sidetxt Cushion">Table:${diamond.Table1}</span><span id="t2" class="sidetxt Cushion">Girdle:${diamond.Girdle1}</span><span id="t3" class="sidetxt Cushion">Culet:${diamond.Culet1}</span><span id="t4" class="sidetxt Cushion">Depth:${diamond.Depth1}</span></div><img src="${proportions_image12}" alt="" id="diamond-img5">`);
                        $('.carousel-inner .diamond-image-mob-5').html(`<div class="diamond-data ${diamond.Shape1}"><span id="table" class="sidetxt Cushion">Table:${diamond.Table1}</span><span id="t2" class="sidetxt Cushion">Girdle:${diamond.Girdle1}</span><span id="t3" class="sidetxt Cushion">Culet:${diamond.Culet1}</span><span id="t4" class="sidetxt Cushion">Depth:${diamond.Depth1}</span></div><img src="${proportions_image12}" alt="" id="diamond-img6">`);
                } 
            });
            
      
              checkImageExists(plotting_image12, function(exists) {
              if (exists) { 
                        $('div#info-section #diamond-image6').html(`<div class="diamond-data ${diamond.Shape1}"><span id="t5" class="sidetxt Cushion">Lenght:${length1}</span><span id="t6" class="sidetxt Cushion">Width:${width1}</span></div><img src="${plotting_image12}" alt="" id="diamond-img4">`);
                       $('.carousel-inner .diamond-image-mob-6').html(`<div class="diamond-data ${diamond.Shape1}"><span id="t5" class="sidetxt Cushion">Lenght:${length1}</span><span id="t6" class="sidetxt Cushion">Width:${width1}</span></div><img src="${plotting_image12}" alt="" id="diamond-img4">`);
                   } 
            });

          
          checkImageExists(gia_certificate_image1, function(exists) {
            count = count +1;
                    if (exists) {
                        $('div#info-section #diamond-image8').html(`<img src="${gia_certificate_image1}" alt="" id="diamond-img3"><span class="diamondtext">Diamond 2</span>`);
                      $('.carousel-inner .diamond-image-mob-8').html(`<img src="${gia_certificate_image1}" alt="" id="diamond-img5new">`);
                    } 
            });




          
          if ($(window).width() < 768) {
          function sliderint() {
           
            if($('.main_container_first.mob-iframe iframe,.main_container_first video').length >0 &&  $('.carousel-inner .carousel-item1:empty').length >0 && count == 1){
              console.log(count);
              $('#carouselExampleIndicators .carousel-inner').slick('unslick');
              $('.carousel-inner .carousel-item1:empty').remove();
              $('#carouselExampleIndicators .carousel-inner').slick({
              dots: true});
              clearInterval(sliderclear);
             }else{
              setTimeout(function(){
                 clearInterval(sliderclear);
               },4000)
             }
          }
             var sliderclear = setInterval(sliderint, 100);
           }
        })
        .catch(error => console.error('Error:', error));











  
}

function updateLocalStorageWizard(stoneInfo, stone_carat, stone_price,url,delivery) { 
   
    let wizardInfo = localStorage.getItem('wizardInfo_dyoe');    
    
    localStorage.removeItem('wizardInfo_dyoe');

    if (wizardInfo != null) {
        wizardInfo = JSON.parse(wizardInfo);
        wizardInfo.stone_shape = stoneInfo.Shape2;
        wizardInfo.stone_carat = stone_carat;
        wizardInfo.stone_price = stone_price;       
        wizardInfo.stone_image_url = url;
        wizardInfo.stone_clarity = stoneInfo.Clarity2;
        wizardInfo.stone_color = stoneInfo.Color2;
        wizardInfo.stone_cut = stoneInfo.Cut2;
        wizardInfo.stone_id=stoneInfo.Diamond_ID2;
        wizardInfo.stone_certificate_no = stoneInfo.Certificate_Number2; 
        wizardInfo.stone_certificate_type = stoneInfo.Lab2;
        wizardInfo.stone_shape1 = stoneInfo.Shape1;
        wizardInfo.stone_carat1 = stoneInfo.Weight1;
        wizardInfo.stone_price1 = stoneInfo.Total_Price1;       
        wizardInfo.stone_image_url1 = url;
        wizardInfo.stone_clarity1 = stoneInfo.Clarity1;
        wizardInfo.stone_color1 = stoneInfo.Color1;
        wizardInfo.stone_cut1 = stoneInfo.Cut1;
        wizardInfo.stone_id1 =stoneInfo.Diamond_ID1;
        wizardInfo.stone_certificate_no1 = stoneInfo.Certificate_Number1; 
        wizardInfo.stone_certificate_type1 = stoneInfo.Lab1;
        wizardInfo.setting_stone_type='Natural White Diamonds';
        wizardInfo.stone_delivery=delivery
         wizardInfo.setting_selected_shape = stoneInfo.Shape1;
        /* also update the window.wizardInfo in the future let's try to avoid using window*/
        window.wizard.stone_shape = stoneInfo.Shape2;
        window.wizard.stone_carat = stone_carat;
        window.wizard.stone_price = stone_price;
        window.wizard.stone_image_url = url;
        window.wizard.stone_clarity = stoneInfo.Clarity2;
        window.wizard.stone_color = stoneInfo.Color2;
        window.wizard.stone_cut = stoneInfo.Cut2;
        window.wizard.stone_shape1 = stoneInfo.Shape1;
        window.wizard.stone_carat1 = stoneInfo.Weight1;
        window.wizard.stone_price1 = stoneInfo.Total_Price1;
        window.wizard.stone_image_url1 = url;
        window.wizard.stone_clarity1 = stoneInfo.Clarity1;
        window.wizard.stone_color1 = stoneInfo.Color1;
        window.wizard.stone_cut1 = stoneInfo.Cut1;
       
      
        window.wizard.setting_stone_type='Natural White Diamonds';
        window.wizard.stone_delivery=delivery
      localStorage.setItem("wizardInfo_dyoe", JSON.stringify(wizardInfo));
    }else if(wizardInfo == null){
     wizardInfo = window.wizard;
      wizardInfo = JSON.parse(wizardInfo);
      wizardInfo.stone_shape = stoneInfo.Shape2;
      wizardInfo.stone_carat = stone_carat;
      wizardInfo.stone_price = stone_price;       
      wizardInfo.stone_image_url = url;
      wizardInfo.stone_clarity = stoneInfo.Clarity2;
      wizardInfo.stone_color = stoneInfo.Color2;
      wizardInfo.stone_cut = stoneInfo.Cut2;
      wizardInfo.setting_stone_type='Natural White Diamonds';
      wizardInfo.stone_delivery=delivery;
      wizardInfo.stone_id=stoneInfo.Diamond_ID2;
      wizardInfo.stone_certificate_no = stoneInfo.Certificate_Number2; 
      wizardInfo.stone_certificate_type = stoneInfo.Lab2;
      wizardInfo.stone_vendor_name = stoneInfo.Seller_Name2;
      wizardInfo.stone_shape1 = stoneInfo.Shape1;
      wizardInfo.stone_carat1 = stoneInfo.Weight1;
      wizardInfo.stone_price1 = stoneInfo.Total_Price1;       
      wizardInfo.stone_image_url1 = url;
      wizardInfo.stone_clarity1 = stoneInfo.Clarity1;
      wizardInfo.stone_color1 = stoneInfo.Color1;
      wizardInfo.stone_cut1 = stoneInfo.Cut1;
      wizardInfo.stone_id1=stoneInfo.Diamond_ID1;
      wizardInfo.stone_certificate_no1 = stoneInfo.Certificate_Number1; 
      wizardInfo.stone_certificate_type1 = stoneInfo.Lab1;
      wizardInfo.stone_vendor_name1 = stoneInfo.Seller_Name1;
      wizardInfo.setting_selected_shape = stoneInfo.Shape1;
      
      wizardInfo = JSON.stringify(wizardInfo);
     // wizardInfo = `{"stepId":1,"setting_variant_id":0,"setting_product_name":"","setting_variant_price":0,"setting_image_url":"","selected_shape":"","setting_selected_carat_size":"","setting_stone_type":"Natural White Diamonds","stone_shape":"${stoneInfo.Shape}","stone_carat":${stone_carat},"stone_price":${stone_price},"stone_id":${stoneInfo.Diamond_ID},"stone_clarity":"${stoneInfo.Clarity}","stone_color":"${stoneInfo.Color}","stone_cut":"${stoneInfo.Cut}","stone_delivery":"${delivery}","setting_product_handle":"","setting_product_id":"","setting_variant_sku":"","setting_min_carat_size":0,"setting_max_carat_size":0,"setting_allowed_shapes":[],"setting_selected_shape":"","setting_selected_metal":"","setting_side_carat_weight":"","stone_image_url":"${url}"}`
     localStorage.setItem("wizardInfo_dyoe", wizardInfo);
    }
    return wizardInfo.setting_stone_type;
}

function bindEventsBtnUseDiamond() {
    let btn = document.getElementById('diamond-with-setting');
    let processing = false;
    let btnText = null;
    let spinner = ` <svg class="tw-w-10 tw-h-10" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
        <g fill="none" fill-rule="evenodd">
            <g transform="translate(1 1)" stroke-width="2">
                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                <path d="M36 18c0-9.94-8.06-18-18-18">
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 18 18"
                        to="360 18 18"
                        dur="1s"
                        repeatCount="indefinite"/>
                </path>
            </g>
        </g>
    </svg>`;
     btn.addEventListener('click', (event) => {
       if(!processing) {
         processing = true;
         $('#stock-modal').remove();
         btnText = $(btn).html();
         $(btn).html(spinner+' Please wait...');
         const queryString = window.location.search;
         let urlParams = new URLSearchParams(queryString);
         let diamond_id = urlParams.get('did');
         let url = window.API_URL +`diamonds/new/dyor/settings/${diamond_id}`;
      
         fetch(url, {
            method: 'GET',        
            headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
         }).then(res => res.json())
          .then(async diamond => {
            processing = false;
            if(diamond && diamond.Diamond_ID2) {
              let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));
              let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));
              if(wizardInfo.setting_product_handle == null || wizardInfo.setting_product_handle == ''){
                url = window.location.origin+"/collections/design-your-own-earrings?sw=s";
              }else{
                  url = window.location.origin+"/pages/complete-earrings?product_handle="+wizardInfo.setting_product_handle;
              }
              window.location.href = url;
            } else {
              $(btn).html(btnText);
              $('body').append("<div id='stock-modal'><div onclick='$(this).parent().remove();' class='stock-modal-close'>X</div>We're so sorry the diamond you selected is no longer available, please choose another before placing your order.</div>");
            }
              
          })
          .catch(error => console.error('Error:', error));
       }
     });
}

function bindEvents() {
    bindEventsBtnUseDiamond();
}

//#region Comparator

function getCompImageUrl(comp_stone){
  console.log(comp_stone,'comp');
  console.log(comp_stone.Shape2,'comp_shape');
    let cutImgPath = ''
    var imgUrl;
    var imgUrljpg;
    var imgUrljpeg;
    if(comp_stone.Shape2 == 'Round'){
      cutImgPath = '_'+comp_stone.Cut2.replace(" ","-").toLowerCase(); // _very-good
    }
  if(comp_stone.Shape2 != undefined){
    imgUrl = isImage(comp_stone.Image_URL2)?comp_stone.Image_URL2:'https://dummyimage.com/420x420/c9c9c9/000000?text='+comp_stone.Shape2.toLowerCase()+'_'+comp_stone.Color2.toLowerCase()+cutImgPath+"_main.png"
    if(comp_stone.Image_URL2.indexOf('mp4')>-1|| comp_stone.Column812.indexOf('mp4')>-1){
    imgUrljpg= `https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${comp_stone.Diamond_ID2}.jpg`;
     if(isImage(imgUrljpg)){
      imgUrl=imgUrljpg
     } 
    }else{
    imgUrljpeg = `https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${comp_stone.Diamond_ID2}.jpeg`;
      if(isImage(imgUrljpeg)){
      imgUrl=imgUrljpeg
     }
    }
  }else{
    imgUrl = isImage(comp_stone.Image_URL2)?comp_stone.Image_URL2:'https://dummyimage.com/420x420/c9c9c9/000000?text='+comp_stone.Shape2.toLowerCase()+'_'+comp_stone.Color2.toLowerCase()+cutImgPath+"_main.png"
    
    if(comp_stone.Image_URL2.indexOf('mp4')>-1 || comp_stone.Column812.indexOf('mp4')>-1){
    imgUrljpg= `https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${comp_stone.Diamond_ID2}.jpg`;
     if(isImage(imgUrljpg)){
      imgUrl=imgUrljpg
     }
    }else{
    imgUrl = `https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${comp_stone.Diamond_ID2}.jpeg`;
    if(isImage(imgUrljpeg)){
      imgUrl=imgUrljpeg
     }
    }
  }
    
    return imgUrl;
}

async function getStoneComparator(typeSearch, stone_id, stone_price, filtersData,settingFilters=false) {
    let url = window.API_URL + `diamonds/new/dyor/settings?page=1&limit=2&sort_by=total_sales_price&direction=ASC`;
    console.log("SettingFilters",settingFilters);
    if(settingFilters){
        filtersObject= JSON.parse(filtersData);
        if(filtersObject.min_carat<settingFilters.min_allowed_carat){
            filtersObject.min_carat=settingFilters.min_allowed_carat;
        }
        if(filtersObject.max_carat>settingFilters.max_allowed_carat){
            filtersObject.max_carat=settingFilters.max_allowed_carat;
        }
        if(filtersObject.Shapes[0].toLowerCase().includes('cushion')){
            filtersObject.Shapes[0] = 'Cushion';
        }
        if(settingFilters.filters.shapes.indexOf(filtersObject.Shapes[0])<0){
            filtersObject.Shapes=settingFilters.filters.shapes;
        }
        filtersData = JSON.stringify(filtersObject);
        console.log("FiltersData",filtersData);
    }


    let response = await fetch(url, {
        method: 'POST',
        body: filtersData,
        headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
    });    
    
    await response.json()
        .then(response => {

            let stones = response.diamonds;
          console.log(stones,'sssstones');
            console.log("Total Stones Found for "+typeSearch+": " + response.search.total);
            if (response.search.total > 0) {
                
                if (response.search.total === 1 && stones[0].diamond_id2 === stone_id ) {
                    return;
                }

                let comp_stone = stones[0].diamond_id2 != stone_id ? stones[0] : stones[1];

                let price_difference = stone_price - comp_stone.total_sales_price2;
                
                let comp_stone_difference;

                if (price_difference === 0) {
                    comp_stone_difference = `$0`;
                }
                
                if (price_difference > 0) {
                    comp_stone_difference = `- ${toCurrencyFormat(price_difference.toString())}`;
                }

                if (price_difference < 0) {
                    price_difference = price_difference * -1;
                    comp_stone_difference = `+ ${toCurrencyFormat(price_difference.toString())}`;
                }

                switch (typeSearch) {
                    case 'morecolor':
                        document.getElementById('comp-morecolor-img').src = getCompImageUrl(comp_stone);
                        document.getElementById('comp-morecolor-price').innerHTML = `${toCurrencyFormat(comp_stone.total_sales_price)}`;
                        document.getElementById('comp-morecolor-difference').innerHTML = `${comp_stone_difference}`;
                        document.getElementById('comp-morecolor-shape').innerHTML = comp_stone.shape;
                        document.getElementById('comp-morecolor-carat').innerHTML =  `${toNumberFormat(comp_stone.size)}`;
                        document.getElementById('comp-morecolor-cut').innerHTML = `${comp_stone.cut}`;
                        document.getElementById('comp-morecolor-color').innerHTML = `${comp_stone.color}`;
                        document.getElementById('comp-morecolor-clarity').innerHTML = `${comp_stone.clarity}`;

                        document.getElementById('comp-morecolor-view').addEventListener('click', () => {
                            setLocalStorageId(comp_stone.diamond_id);
                            //updateLocalStorageWizard(comp_stone, comp_stone.size, comp_stone.Total_Price,comp_stone.image_url,delivery);
                            window.location.href = window.location.origin + '/pages/diamond-detail-dyoe?did='+comp_stone.diamond_id;
                        });
                        
                        document.getElementById('comp-morecolor').classList.remove('hidden');
                        break;

                    case 'similar':
                        document.getElementById('comp-similar-img').src = getCompImageUrl(comp_stone);
                        document.getElementById('comp-similar-price').innerHTML = `${toCurrencyFormat(comp_stone.total_sales_price2)}`;
                        document.getElementById('comp-similar-difference').innerHTML = `${comp_stone_difference}`;
                        document.getElementById('comp-similar-shape').innerHTML = comp_stone.shape2;
                        document.getElementById('comp-similar-carat').innerHTML =  `${toNumberFormat(comp_stone.size2)}`;
                        document.getElementById('comp-similar-cut').innerHTML = `${comp_stone.cut2}`;
                        document.getElementById('comp-similar-color').innerHTML = `${comp_stone.color2}`;
                        document.getElementById('comp-similar-clarity').innerHTML = `${comp_stone.clarity2}`;

                        document.getElementById('comp-similar-view').addEventListener('click', () => {
                            setLocalStorageId(comp_stone.diamond_id);
                            window.location.href = window.location.origin + '/pages/diamond-detail?did='+comp_stone.diamond_id;
                        });
                        
                        document.getElementById('comp-similar').classList.remove('hidden');
                        break;

                    case 'bigger':
                        document.getElementById('comp-bigger-img').src = getCompImageUrl(comp_stone);
                        document.getElementById('comp-bigger-price').innerHTML = `${toCurrencyFormat(comp_stone.total_sales_price2)}`;
                        document.getElementById('comp-bigger-difference').innerHTML = `${comp_stone_difference}`;
                        document.getElementById('comp-bigger-shape').innerHTML = comp_stone.shape2;
                        document.getElementById('comp-bigger-carat').innerHTML =  `${toNumberFormat(comp_stone.size2)}`;
                        document.getElementById('comp-bigger-cut').innerHTML = `${comp_stone.cut2}`;
                        document.getElementById('comp-bigger-color').innerHTML = `${comp_stone.color2}`;
                        document.getElementById('comp-bigger-clarity').innerHTML = `${comp_stone.clarity2}`;

                        document.getElementById('comp-bigger-view').addEventListener('click', () => {
                            setLocalStorageId(comp_stone.diamond_id2);
                            window.location.href = window.location.origin + '/pages/diamond-detail?did='+comp_stone.diamond_id2;
                        });
                        
                        document.getElementById('comp-bigger').classList.remove('hidden');
                        break;

                    case 'smaller':
                        document.getElementById('comp-smaller-img').src = getCompImageUrl(comp_stone);
                        document.getElementById('comp-smaller-price').innerHTML = `${toCurrencyFormat(comp_stone.total_sales_price)}`;
                        document.getElementById('comp-smaller-difference').innerHTML = `${comp_stone_difference}`;
                        document.getElementById('comp-smaller-shape').innerHTML = comp_stone.shape2;
                        document.getElementById('comp-smaller-carat').innerHTML =  `${toNumberFormat(comp_stone.size2)}`;
                        document.getElementById('comp-smaller-cut').innerHTML = `${comp_stone.cut2}`;
                        document.getElementById('comp-smaller-color').innerHTML = `${comp_stone.color2}`;
                        document.getElementById('comp-smaller-clarity').innerHTML = `${comp_stone.clarity2}`;

                        document.getElementById('comp-smaller-view').addEventListener('click', () => {
                            setLocalStorageId(comp_stone.diamond_id2);
                            window.location.href = window.location.origin + '/pages/diamond-detail?did='+comp_stone.diamond_id2;
                        });
                        
                        document.getElementById('comp-smaller').classList.remove('hidden');
                        break;
                   
                }
                  
            }
            var total_compare = parseInt($('.list-group.comparator-item').length);
                    var total_hide_comp = parseInt($('.comparator-item.hidden').length);
                    var total_show_comp = total_compare-total_hide_comp;
                    if(total_show_comp > 1){
                       
                        $('#comparator-section').removeClass('hidden');
                    }else{
                         $('#comparator-section').addClass('hidden');
                    }
        })
        .catch(error => console.error('Error:', error));
}

async function loadComparatorCurrentStone(stone) {
    console.log("Comparator: Loading Current Stone");
    
    let price = toCurrencyFormat(stone.Total_Price2);
    let carat = toNumberFormat(stone.Weight2); 
    
    document.getElementById('comp-current-img').src = getCompImageUrl(stone);
    document.getElementById('comp-current-price').innerHTML = `${price}`;    
    document.getElementById('comp-current-shape').innerHTML = `${stone.Shape2}`;
    document.getElementById('comp-current-carat').innerHTML = `${carat}`;
    document.getElementById('comp-current-cut').innerHTML = `${stone.Cut2}`;
    document.getElementById('comp-current-color').innerHTML = `${stone.Color2}`;
    document.getElementById('comp-current-clarity').innerHTML = `${stone.Clarity2}`;

    document.getElementById('comp-currentstone').classList.remove('hidden');
}

async function loadComparatorMoreColor(stone, settingFilters = false){
    console.log("Comparator: Loading More Color");
    
    let carat_from;
    let carat_to;
    let color;    
    let price_from;
    let price_to;

    // Pedido: 
    // carat: +- 0.01
    // price: +- 1%
    // color: +1pos

     carat_from = toNumberFormat(stone.Weight2 - 0.01); //0.01
     carat_to = toNumberFormat(stone.Weight2 + 0.01); //0.01
    // carat_from = 0.25;
    // carat_to = 5;
    

    let one_percent = stone.Total_Price2 * 0.01; // 0.01
     price_from = parseInt(stone.Total_Price2 - one_percent);
     price_to = parseInt(stone.Total_Price2 + one_percent);
    //price_from = 410;
    //price_to = 5000;

    let colorValues = ['J', 'I', 'H', 'G', 'F', 'E', 'D'];
    let moreColorIndex = colorValues.indexOf(stone.Color2) != 0 ? colorValues.indexOf(stone.Color2) - 1 : colorValues.indexOf(stone.Color2)
    color = colorValues[moreColorIndex];
    console.log("COLOR STONE INFO",stone);

    let filtersData = `{
        "size_from": "${carat_from}",
        "size_to": "${carat_to}",
        "price_total_from": "${price_from}",
        "price_total_to": "${price_to}",
        "cut_from": "${stone.Cut2}",
        "cut_to": "${stone.Cut2}",
        "color_from": "${color}",
        "color_to": "${color}",
        "clarity_from": "${stone.Clarity2}",
        "clarity_to": "${stone.Clarity2}",
        "labs": ["${stone.Lab2}"],
        "Shapes": ["${stone.Shape2}"]
        }`;

        

    await getStoneComparator('morecolor', stone.Diamond_ID2, stone.Total_Price2, filtersData,settingFilters);
}

async function loadComparatorSimilar(stone,settingFilters=false){
    console.log("Comparator: Loading Similar");
    
    let carat_from;
    let carat_to;
    let price_from;
    let price_to;

    // Pedido: 
    // carat: +- 0.01
    // price: +- 1%

     carat_from = toNumberFormat(stone.Weight2 - 0.01);
     carat_to = toNumberFormat(stone.Weight2 + 0.01);
    //carat_from = 0.25;
    //carat_to = 5;

     let one_percent = stone.Total_Price2 * 0.09;
     price_from = parseInt(stone.Total_Price2 - one_percent);
     price_to = parseInt(stone.Total_Price2 + one_percent);
    //price_from = 410;
    //price_to = 5000;

    let filtersData = `{
        "size_from": "${carat_from}",
        "size_to": "${carat_to}",
        "price_total_from": "${price_from}",
        "price_total_to": "${price_to}",
        "cut_from": "${stone.Cut2}",
        "cut_to": "${stone.Cut2}",
        "color_from": "${stone.Color2}",
        "color_to": "${stone.Color2}",
        "clarity_from": "${stone.Clarity2}",
        "clarity_to": "${stone.Clarity2}",
        "labs": ["${stone.Lab2}"],
        "Shapes": ["${stone.Shape2}"]
        }`;        

    await getStoneComparator('similar', stone.Diamond_ID2, stone.Total_Price2, filtersData,settingFilters);
}

async function loadComparatorBigger(stone,settingFilters=false){
    console.log("Comparator: Loading Bigger");
    
    let carat_from;
    let carat_to;
    let color;
    let price_from;
    let price_to;

    // Pedido: 
    // carat: + 7% y 12%
    // color: +1pos

    let seven_percent = stone.Weight2 * 0.10; // 0.07
    let twelve_percent = stone.Weight2 * 1.50; // 0.12
    carat_from = toNumberFormat(stone.Weight2 + seven_percent);
    carat_to = toNumberFormat(stone.Weight2 + twelve_percent);

    let colorValues = ['J', 'I', 'H', 'G', 'F', 'E', 'D'];
    let moreColorIndex = colorValues.indexOf(stone.Color2) != 0 ? colorValues.indexOf(stone.Color2) - 1 : colorValues.indexOf(stone.Color2)
    color = colorValues[moreColorIndex];

    price_from = 410;
    price_to = 5000;

    let filtersData = `{
        "size_from": "${carat_from}",
        "size_to": "${carat_to}",
        "price_total_from": "${price_from}",
        "price_total_to": "${price_to}",
        "cut_from": "${stone.Cut2}",
        "cut_to": "${stone.Cut2}",
        "color_from": "${color}",
        "color_to": "${color}",
        "clarity_from": "${stone.Clarity2}",
        "clarity_to": "${stone.Clarity2}",
        "labs": ["${stone.Lab2}"],
        "Shapes": ["${stone.Shape2}"]
        }`;        

    await getStoneComparator('bigger', stone.Diamond_ID2, stone.Total_Price2, filtersData,settingFilters);
}

async function loadComparatorSmaller(stone,settingFilters=false){
    console.log("Comparator: Loading Smaller Stone");
    
    let carat_from;
    let carat_to;    

    // Pedido: 
    // carat: - 7% y 12%

    let seven_percent = stone.Weight2 * 0.10; // 0.07
    let twelve_percent = stone.Weight2 * 1.50; // 0.12
    carat_from = toNumberFormat(stone.Weight2 - seven_percent);
    carat_to = toNumberFormat(stone.Weight2 + twelve_percent);

    price_from = 410;
    price_to = 5000;

    let filtersData = `{
        "size_from": "${carat_from}",
        "size_to": "${carat_to}",
        "price_total_from": "${price_from}",
        "price_total_to": "${price_to}",
        "cut_from": "${stone.Cut2}",
        "cut_to": "${stone.Cut2}",
        "color_from": "${stone.Color2}",
        "color_to": "${stone.Color2}",
        "clarity_from": "${stone.Clarity2}",
        "clarity_to": "${stone.Clarity2}",
        "labs": ["${stone.Lab2}"],
        "Shapes": ["${stone.Shape2}"]
        }`;

    await getStoneComparator('smaller', stone.Diamond_ID2, stone.Total_Price2, filtersData,settingFilters);
}

async function loadComparator(stone) {
    let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));
    let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));
    let settingFilters = false;
    console.log("WizardStart",wizardStart);
    if(wizardStart == 'StartWithSetting'){
            settingFilters = {}
            settingFilters.max_allowed_carat = wizardInfo.setting_max_carat_size;
            settingFilters.min_allowed_carat = wizardInfo.setting_min_carat_size;
            settingFilters.allowed_shapes = wizardInfo.setting_allowed_shapes;
            settingFilters.filters = {}
            settingFilters.filters.shapes = wizardInfo.setting_allowed_shapes;
        }
    console.log("Setting Filters",settingFilters);
    await loadComparatorCurrentStone(stone);
    await loadComparatorMoreColor(stone,settingFilters);
    await loadComparatorSimilar(stone,settingFilters);
    await loadComparatorBigger(stone,settingFilters);
    await loadComparatorSmaller(stone,settingFilters);
    
    let loading = document.getElementById('comparator-loading');
    loading.classList.remove('d-flex');
    loading.style.display = 'none';
    document.getElementById('comparator-content').classList.remove('invisible');
}

//#endregion

function setLocalStorageId(stone_id) {
    
    let wizardInfo = localStorage.getItem('wizardInfo_dyoe');    
    
    localStorage.removeItem('wizardInfo_dyoe');

    if (wizardInfo != null) {
        wizardInfo = JSON.parse(wizardInfo);
        wizardInfo.stone_id = stone_id;
    }
    else {
        wizardInfo = window.wizard;
        wizardInfo.stone_id = stone_id;
    }

    localStorage.setItem("wizardInfo_dyoe", JSON.stringify(wizardInfo));
}

function load4Cs(){
    
    let diamondInfo = localStorage.getItem('wizardInfo_dyoe'); 
    diamondInfo = JSON.parse(diamondInfo); 
    
    
    let sizediamond; 
    if (diamondInfo.stone_carat == 0) {
        sizediamond = 0
    }
    if (diamondInfo.stone_carat > 0 && diamondInfo.stone_carat <=0.25) {
        sizediamond = 0
    }
    if (diamondInfo.stone_carat > 0.25 && diamondInfo.stone_carat <=0.5) {
        sizediamond = 1
    }
    if (diamondInfo.stone_carat > 0.5 && diamondInfo.stone_carat <=0.75) {
        sizediamond = 2
    }
    if (diamondInfo.stone_carat > 0.75 && diamondInfo.stone_carat <=1) {
        sizediamond = 3
    }
    if (diamondInfo.stone_carat > 1 && diamondInfo.stone_carat <=1.25) {
        sizediamond = 4
    }
    if (diamondInfo.stone_carat > 1.25 && diamondInfo.stone_carat <=1.5) {
        sizediamond = 5
    }
    if (diamondInfo.stone_carat > 1.5 && diamondInfo.stone_carat <=1.75) {
        sizediamond = 6
    }
    if (diamondInfo.stone_carat > 1.75 && diamondInfo.stone_carat <=2) {
        sizediamond = 7
    }
    if (diamondInfo.stone_carat > 2) {
        sizediamond = 8
    }

   
    const sizeDiamond = document.querySelectorAll('.banner_size_each')
    sizeDiamond.forEach(size=>{
        switch (sizediamond) {
            case 0:
                
                break;
            case 1:
                if (size.id == 'banner_size_each_1') {                       
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.innerHTML=`${parseFloat(diamondInfo.stone_carat).toFixed(2)}CT`;
                    tooltip.style.display = 'flex';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',
                    duration:[0,500000000000000000000000000000],     
                    trigger: "manual",
                    showOnCreate: true,
                    hideOnClick: false,               
                                     
                    })
        
                } else {
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.style.display = 'none';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',   
                    })
                    
                }
            
                break;
            case 2:
                if (size.id == 'banner_size_each_2') {                       
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.innerHTML=`${parseFloat(diamondInfo.stone_carat).toFixed(2)}CT`;
                    tooltip.style.display = 'flex';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',
                    duration:[0,500000000000000000000000000000],     
                    trigger: "manual",
                    showOnCreate: true,
                    hideOnClick: false,               
                                      
                    })
        
                } else {
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.style.display = 'none';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',   
                    })
                    
                }
            
                break;
            case 3:
                if (size.id == 'banner_size_each_3') {                       
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.innerHTML=`${parseFloat(diamondInfo.stone_carat).toFixed(2)}CT`;
                    tooltip.style.display = 'flex';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',
                    duration:[0,500000000000000000000000000000],     
                    trigger: "manual",
                    showOnCreate: true,
                    hideOnClick: false,               
                                      
                    })
        
                } else {
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.style.display = 'none';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',   
                    })
                    
                }
            
                break;
            case 4:
                if (size.id == 'banner_size_each_4') {                       
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.innerHTML=`${parseFloat(diamondInfo.stone_carat).toFixed(2)}CT`;
                    tooltip.style.display = 'flex';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',
                    duration:[0,500000000000000000000000000000],     
                    trigger: "manual",
                    showOnCreate: true,
                    hideOnClick: false,               
                                      
                    })
        
                } else {
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.style.display = 'none';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',   
                    })
                    
                }
            
                break;
            case 5:
                if (size.id == 'banner_size_each_5') {                       
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.innerHTML=`${parseFloat(diamondInfo.stone_carat).toFixed(2)}CT`;
                    tooltip.style.display = 'flex';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',
                    duration:[0,500000000000000000000000000000],     
                    trigger: "manual",
                    showOnCreate: true,
                    hideOnClick: false,               
                                      
                    })          
        
                } else {
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.style.display = 'none';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',   
                    })
                    
                }
            
                break;
            case 6:
                if (size.id == 'banner_size_each_6') {                       
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.innerHTML=`${parseFloat(diamondInfo.stone_carat).toFixed(2)}CT`;
                    tooltip.style.display = 'flex';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',
                    duration:[0,500000000000000000000000000000],     
                    trigger: "manual",
                    showOnCreate: true,
                    hideOnClick: false,               
                                      
                    })           
        
                } else {
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.style.display = 'none';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',   
                    })
                    
                }
            
                break;
            case 7:
                if (size.id == 'banner_size_each_7') {                       
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.innerHTML=`${parseFloat(diamondInfo.stone_carat).toFixed(2)}CT`;
                    tooltip.style.display = 'flex';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',
                    duration:[0,500000000000000000000000000000],     
                    trigger: "manual",
                    showOnCreate: true,
                    hideOnClick: false,               
                                      
                    })         
        
                } else {
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.style.display = 'none';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',   
                    })
                    
                }
            
                break;
            case 8:
                if (size.id == 'banner_size_each_8') {                       
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.innerHTML=`${parseFloat(diamondInfo.stone_carat).toFixed(2)}CT`;
                    tooltip.style.display = 'flex';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',
                    duration:[0,500000000000000000000000000000], 
                    showOnCreate: true,
                    hideOnClick: false,               
                    trigger: "manual"                  
                    })     
        
                } else {
                    const tooltip= size.querySelector('.tooltip_size_diamond')    
                    tooltip.style.display = 'none';
                    tooltip.classList.add('tooltip_size_diamond_style')    
                    tippy(size,{
                    content: tooltip,
                    placement: 'top',   
                    })
                    
                }
            
                break;
            default:
                break;
        }      
    })  
    if(diamondInfo.stone_shape == 'Round'){ 
        const cuts = document.querySelectorAll('.banner_cut_types_each');
        cuts.forEach(cut=>{      
        switch (diamondInfo.stone_cut) {
                case 'Poor':
                    if (cut.id == 'poor') {   
                        const bar = cut.querySelector('.banner_size_bar')
                        bar.style.backgroundColor  = 'rgb(29 29 30)';
                       const tooltip= cut.querySelector('.tooltip_cut')
                      tooltip.style.display = 'block';
                      tooltip.classList.add('tooltip_cut_style');
                      tippy(cut,{
                          content: tooltip,
                          placement: 'top',
                          theme: 'light',
                          showOnCreate: true,
                          hideOnClick: false,  
                          trigger: "manual"
                      });
                    }else{
                      const bar = cut.querySelector('.banner_size_bar')
                        bar.style.backgroundColor  = 'rgb(29 29 30)';
                        const tooltip= cut.querySelector('.tooltip_cut')
                        tooltip.style.display = 'block';
                        tooltip.classList.add('tooltip_cut_style');
                        tippy(cut,{
                          content: tooltip,
                          placement: 'top',
                          theme: 'light',
                          showOnCreate: false,
                          hideOnClick: false,  
                          
                      });
                    }
                    break;
                case 'Fair':
                    if (cut.id == 'fair') { 
                        const bar = cut.querySelector('.banner_size_bar')
                        bar.style.backgroundColor  = 'rgb(29 29 30)';
                        const tooltip= cut.querySelector('.tooltip_cut')
                        tooltip.style.display = 'block';
                        tooltip.classList.add('tooltip_cut_style');
                        tippy(cut,{
                          content: tooltip,
                          placement: 'top',
                          theme: 'light',
                          showOnCreate: true,
                          hideOnClick: false,  
                          trigger: "manual"
                      });
                    }else{
                      const bar = cut.querySelector('.banner_size_bar')
                        bar.style.backgroundColor  = 'rgb(29 29 30)';
                        const tooltip= cut.querySelector('.tooltip_cut')
                        tooltip.style.display = 'block';
                        tooltip.classList.add('tooltip_cut_style');
                        tippy(cut,{
                          content: tooltip,
                          placement: 'top',
                          theme: 'light',
                          showOnCreate: false,
                          hideOnClick: false,  
                          
                      });
                    }
                    break;
                case 'Good':
                    if (cut.id == 'good') {   
                           const bar = cut.querySelector('.banner_size_bar')
                        bar.style.backgroundColor  = 'rgb(29 29 30)';
                        const tooltip= cut.querySelector('.tooltip_cut')
                        tooltip.style.display = 'block';
                        tooltip.classList.add('tooltip_cut_style');
                       tippy(cut,{
                          content: tooltip,
                          placement: 'top',
                          theme: 'light',
                          showOnCreate: true,
                          hideOnClick: false,  
                          trigger: "manual"
                      });
                    }else{
                      const bar = cut.querySelector('.banner_size_bar')
                        bar.style.backgroundColor  = 'rgb(29 29 30)';
                        const tooltip= cut.querySelector('.tooltip_cut')
                        tooltip.style.display = 'block';
                        tooltip.classList.add('tooltip_cut_style');
                        tippy(cut,{
                          content: tooltip,
                          placement: 'top',
                          theme: 'light',
                          showOnCreate: false,
                          hideOnClick: false,  
                          
                      });
                    }
                    break;
                case 'Very Good':
                    if (cut.id == 'veryGood') {
                           const bar = cut.querySelector('.banner_size_bar')
                        bar.style.backgroundColor  = 'rgb(29 29 30)';
                        const tooltip= cut.querySelector('.tooltip_cut')
                        tooltip.style.display = 'block';
                        tooltip.classList.add('tooltip_cut_style');
                         tippy(cut,{
                          content: tooltip,
                          placement: 'top',
                          theme: 'light',
                          showOnCreate: true,
                          hideOnClick: false,  
                          trigger: "manual"
                      });
                    }else{
                      const bar = cut.querySelector('.banner_size_bar')
                        bar.style.backgroundColor  = 'rgb(29 29 30)';
                        const tooltip= cut.querySelector('.tooltip_cut')
                        tooltip.style.display = 'block';
                        tooltip.classList.add('tooltip_cut_style');
                        tippy(cut,{
                          content: tooltip,
                          placement: 'top',
                          theme: 'light',
                          showOnCreate: false,
                          hideOnClick: false  
                         
                      });
                    }
                    break;
                case 'Excellent':
                    if (cut.id == 'excellent') {   
                         const bar = cut.querySelector('.banner_size_bar')
                        bar.style.backgroundColor  = 'rgb(29 29 30)';
                        const tooltip= cut.querySelector('.tooltip_cut')
                        tooltip.style.display = 'block';
                        tooltip.classList.add('tooltip_cut_style');
                        tippy(cut,{
                          content: tooltip,
                          placement: 'top',
                          theme: 'light',
                          showOnCreate: true,
                          hideOnClick: false,  
                          trigger: "manual"
                      });
                    }else{
                      const bar = cut.querySelector('.banner_size_bar')
                        bar.style.backgroundColor  = 'rgb(29 29 30)';
                        const tooltip= cut.querySelector('.tooltip_cut')
                        tooltip.style.display = 'block';
                        tooltip.classList.add('tooltip_cut_style');
                        tippy(cut,{
                          content: tooltip,
                          placement: 'top',
                          theme: 'light',
                          showOnCreate: false,
                          hideOnClick: false 
                          
                      });
                    }
                    break;            
                    
                default:
                    break;
            }   
    
        })
    }
    else {
        document.getElementById('cutCircle').style.display = 'none';
    }

    
    const colorsDiamond = document.querySelectorAll('.banner_color_bg_box')    
    colorsDiamond.forEach(color=>{
        const tooltip = color.querySelector('.tooltip_color_diamond');
        switch (color.id) {
            case "color-box-1":
                    if(color.id == 'color-box-1'){
                       tooltip.style.display = 'block';
                    tooltip.classList.add('tooltip_color_diamond_style');
                    tooltip.innerHTML = `<b>D-F: Absolutely Colorless Or Icy White </b><br/>
                    Color slightly detectable when compared 
                    to diamonds of better grades, a good value.`;
                    
                    var tip1 =tippy(color,{content: tooltip, placement: 'top',theme: 'light'});
                    }
                   
                
            break;

            case "color-box-2":
                tooltip.style.display = 'block';
                tooltip.classList.add('tooltip_color_diamond_style');
                tooltip.innerHTML = `<b>G-J: Near-colorless </b><br/>
                Color slightly detectable when compared 
                to diamonds of better grades, a good value.`;

                 var tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light'});
          
            break;

            case "color-box-3":
                tooltip.style.display = 'block';
                tooltip.classList.add('tooltip_color_diamond_style');
                tooltip.innerHTML = `<b>K-Z: Noticeable-color </b><br/>
                    Color slightly detectable when compared 
                    to diamonds of better grades, a good value.`;
                 var tip3 =tippy(color,{content: tooltip, placement: 'top',theme: 'light'});
          
            break;
        }
        switch (diamondInfo.stone_color) {
            case 'J':   
               if (color.id == 'color-box-2') {                       
                    const img = color.querySelector('.diamond_color_bg');                   
                    img.style.border = "2px solid black";
                 tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: true, hideOnClick: false,trigger: "manual" });
                 
                }else{
                 tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: false, hideOnClick: false});
                }
                break;
            case 'I': 
                if (color.id == 'color-box-2') {                  
                    const img = color.querySelector('.diamond_color_bg');                   
                    img.style.border = "2px solid black";  
                   tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: true, hideOnClick: false,trigger: "manual"});
                }else{
                  tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: false, hideOnClick: false});
                }   
                break;
            case 'H':
                if (color.id == 'color-box-2') {                  
                    const img = color.querySelector('.diamond_color_bg');                   
                    img.style.border = "2px solid black";
                    tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: true, hideOnClick: false,trigger: "manual" });
                }else{
                  tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: false, hideOnClick: false });
                }
                break;
            case 'G':
                if (color.id == 'color-box-2') {                  
                    const img = color.querySelector('.diamond_color_bg');                   
                    img.style.border = "2px solid black"; 
                    tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: true, hideOnClick: false,trigger: "manual" });
                }else{
                  tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: false, hideOnClick: false });
                }
                break;
            case 'F':
                if (color.id == 'color-box-1') {                  
                    const img = color.querySelector('.diamond_color_bg');                   
                    img.style.border = "2px solid black";
                     tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: true, hideOnClick: false,trigger: "manual" });
                }else{
                   tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: false, hideOnClick: false });
                }
                break;
            case 'E':
                if (color.id == 'color-box-1') {                  
                    const img = color.querySelector('.diamond_color_bg');                   
                    img.style.border = "2px solid black";
                    tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: true, hideOnClick: false,trigger: "manual"  });
                }else{
                   tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: false, hideOnClick: false });
                } 
                break;
            case 'D':
                if (color.id == 'color-box-1') {
                 const img = color.querySelector('.diamond_color_bg');                   
                    img.style.border = "2px solid black";
                     tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: true, hideOnClick: false,trigger: "manual" });
                }else{
                   tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: false, hideOnClick: false });
                }
                
                break;
        
            default:
                if (color.id == 'color-box-3') {                  
                    const img = color.querySelector('.diamond_color_bg');                   
                    img.style.border = "2px solid black";
                     tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: true, hideOnClick: false,trigger: "manual" });
                }else{
                 tip2 =tippy(color,{content: tooltip, placement: 'top',theme: 'light', showOnCreate: fasle, hideOnClick: false }); 
                } 
                break;
        }

  
    })

    const clarities = document.querySelectorAll('.banner_clarity_types_each')
    clarities.forEach(clarity=>{

        if (diamondInfo.stone_clarity == "IF" && size.id == "banner_size_each_8") {
            const tooltip= size.querySelector('.tooltip_size_diamond')    
            tooltip.innerHTML=`${diamondInfo.stone_carat}`;
            tooltip.style.display = 'flex';
            tooltip.classList.add('tooltip_size_diamond_style')    
            tippy(size,{
                content: tooltip,
                placement: 'top',
                duration:[0,500000000000000000000000000000],     
                trigger: "manual",
                showOnCreate: true,
                hideOnClick: true,  
                theme: 'light',
                trigger: "manual"
                                    
            })
        }
         else {
            var tooltip= clarity.querySelector('.tooltip_clarity')
            tooltip.style.display = 'block';
            tooltip.classList.add('tooltip_clarity_style');

            var tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                hideOnClick: false,
            });
        }
        switch (diamondInfo.stone_clarity) {
            case 'I3':               
                if (clarity.id == 'i3') {   
                    const bar = clarity.querySelector('.banner_size_bar')
                    bar.style.backgroundColor  = 'rgb(29 29 30)';
                    tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                showOnCreate: true,
                hideOnClick: false,
                trigger: "manual"
            });
                }else{
                const bar = clarity.querySelector('.banner_size_bar')
                bar.style.backgroundColor  = 'rgb(29 29 30)';
                tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                hideOnClick: false
                });
                }
                break;
            case 'I2':
                if (clarity.id == 'i2') {
                    const bar = clarity.querySelector('.banner_size_bar')
                    bar.style.backgroundColor  = 'rgb(29 29 30)'; 
                    tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                showOnCreate: true,
                hideOnClick: false,
                trigger: "manual"
            });
                }else{
                const bar = clarity.querySelector('.banner_size_bar')
                bar.style.backgroundColor  = 'rgb(29 29 30)';
                tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                hideOnClick: false
                });
                }
                break;
            case 'I1':
                if (clarity.id == 'i1') {   
                    const bar = clarity.querySelector('.banner_size_bar')
                    bar.style.backgroundColor  = 'rgb(29 29 30)';
                    tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                showOnCreate: true,
                hideOnClick: true,
                trigger: "manual"
            });
                }else{
                const bar = clarity.querySelector('.banner_size_bar')
                bar.style.backgroundColor  = 'rgb(29 29 30)';
                tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                hideOnClick: false
                });
                }
                break;
            case 'SI3':
                if (clarity.id == 'si3') {   
                    const bar = clarity.querySelector('.banner_size_bar')
                    bar.style.backgroundColor  = 'rgb(29 29 30)';
                   tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                showOnCreate: true,
                hideOnClick: false,
                trigger: "manual"
            });
                }else{
                const bar = clarity.querySelector('.banner_size_bar')
                bar.style.backgroundColor  = 'rgb(29 29 30)';
                tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                hideOnClick: false
                });
                }
                break;
            case 'SI2':
                if (clarity.id == 'si2') {   
                    const bar = clarity.querySelector('.banner_size_bar')
                    bar.style.backgroundColor  = 'rgb(29 29 30)';
                    tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                showOnCreate: true,
                hideOnClick: false,
                trigger: "manual"
            });
                }else{
                const bar = clarity.querySelector('.banner_size_bar')
                bar.style.backgroundColor  = 'rgb(29 29 30)';
                tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                hideOnClick: false
                });
                }
                break;
            case 'SI1':
                if (clarity.id == 'si1') {   
                    const bar = clarity.querySelector('.banner_size_bar')
                    bar.style.backgroundColor  = 'rgb(29 29 30)';
                   tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                showOnCreate: true,
                hideOnClick: false,
                trigger: "manual"
            });
                }else{
                const bar = clarity.querySelector('.banner_size_bar')
                bar.style.backgroundColor  = 'rgb(29 29 30)';
                tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                hideOnClick: false
                });
                }
                break;
            case 'VS2':
                if (clarity.id == 'vs2') {   
                    const bar = clarity.querySelector('.banner_size_bar')
                    bar.style.backgroundColor  = 'rgb(29 29 30)';
                   tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                showOnCreate: true,
                hideOnClick: false,
                trigger: "manual"
            });
                }else{
                const bar = clarity.querySelector('.banner_size_bar')
                bar.style.backgroundColor  = 'rgb(29 29 30)';
                tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                hideOnClick: false
                });
                }
                break;
            case 'VS1':
                if (clarity.id == 'vs1') {   
                    const bar = clarity.querySelector('.banner_size_bar')
                    bar.style.backgroundColor  = 'rgb(29 29 30)';
                    tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                showOnCreate: true,
                hideOnClick: false,
                trigger: "manual"
            });
                }else{
                const bar = clarity.querySelector('.banner_size_bar')
                bar.style.backgroundColor  = 'rgb(29 29 30)';
                tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                hideOnClick: false
                });
                }
                break;
            case 'VVS2':
                if (clarity.id == 'vvs2') {   
                    const bar = clarity.querySelector('.banner_size_bar')
                    bar.style.backgroundColor  = 'rgb(29 29 30)';
                    tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                showOnCreate: true,
                hideOnClick: false,
                trigger: "manual"
            });
                }else{
                const bar = clarity.querySelector('.banner_size_bar')
                bar.style.backgroundColor  = 'rgb(29 29 30)';
                tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                hideOnClick: false
                });
                }
                break;
            case 'VVS1':
                if (clarity.id == 'vvs1') {   
                    const bar = clarity.querySelector('.banner_size_bar')
                    bar.style.backgroundColor  = 'rgb(29 29 30)';
                  tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                showOnCreate: true,
                hideOnClick: false,
                trigger: "manual"
            });
                }else{
                const bar = clarity.querySelector('.banner_size_bar')
                bar.style.backgroundColor  = 'rgb(29 29 30)';
                tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                hideOnClick: false
                });
                }
                break;
            case 'IF':
                if (clarity.id == 'if') {   
                    const bar = clarity.querySelector('.banner_size_bar')
                    bar.style.backgroundColor  = 'rgb(29 29 30)';
                   tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                showOnCreate: true,
                hideOnClick: false,
                trigger: "manual"
            });
                }else{
                const bar = clarity.querySelector('.banner_size_bar')
                bar.style.backgroundColor  = 'rgb(29 29 30)';
                tip2= tippy(clarity,{
                content: tooltip,
                placement: 'top', 
                theme: 'light',
                hideOnClick: false
                });
                }
                break;
            default:
                break;
        }      


    })
    

}

(function(){
    let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));
    console.log(wizardInfo);
    //get the did querystring parameter and callOneDiamond with that id
    if (wizardInfo == null) {
       //window.location.href = window.location.origin + '/pages/dyor-diamonds';
    }
   //  let stone_image_url = wizardInfo.stone_image_url;
   // if($('.banner_size_box').length > 0 &&  stone_image_url != null && stone_image_url != ''){
   //   $('.banner_size_images').find('.banner_size_each img').attr('src',stone_image_url);
   //   }
    const queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    let did = urlParams.get('did');
    if (did != null) {
        callOneDiamond(did);
    }
    else {
       window.location.href = window.location.origin + '/pages/dyor-diamonds';
    }    
    bindEvents();
   
   $(document).on('click','.popup_close_icon_cstm',function(e){
     e.preventDefault();
      $(this).parents('.image_popup_content').hide();
    });
   $(document).on('click','.image_popup_content',function(e){
     e.preventDefault();
       if (!$(e.target).closest(".popup_content_inner").length) {
      $(this).hide();
       }
      });
  
  
})();
$(document).on('click','#diamond-image5 img',function(e){
     e.preventDefault();
    var imgURL= $(this).attr('src');
      $('.image_popup_content img').attr('src',imgURL);
       $('.image_popup_content').css('display','grid');
    });
$(document).on('click','.main_video_container',function (params) {
    $(this).find('.play_btn,.diamond_image').hide();
})
$(window).bind("load resize",function(e){
  if($(window).width() > 831){
    $(document).on('click','.content_popup',function(e){
     e.preventDefault();
    var imgURL= $(this).attr('href');
      $('.image_popup_content img').attr('src',imgURL);
       $('.image_popup_content').show();
    });
  }
});

